module.exports = __webpack_public_path__ + "static/template_linen-ee009e81ce59e3e74914aadf3979864d.png";